var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.15 3.55132L21.5398 5.23144C21.8298 5.57146 21.9998 6.02148 21.9997 6.50148L21.9987 19.0015C21.9986 20.1015 21.0985 21.0014 19.9985 21.0013L5.99852 21.0002C4.89852 21.0001 3.9986 20.1 3.99869 19L3.99971 6.5C3.99975 6.02 4.16979 5.57001 4.45982 5.23004L5.83995 3.55015C6.11998 3.21017 6.53 3.00021 7 3.00025L19 3.00123C19.47 3.00127 19.88 3.2113 20.15 3.55132ZM18.7598 5.00121L7.23984 5.00027L6.43976 5.9702L19.5698 5.97128L18.7598 5.00121ZM5.99869 19.0002L5.99959 8.00016L19.9996 8.00131L19.9987 19.0013L5.99869 19.0002ZM11.5494 10.0006L14.4494 10.0009L14.4492 13.0009L16.9992 13.0011L12.9989 17.0007L8.99918 13.0004L11.5492 13.0006L11.5494 10.0006Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive24Px);
export default __webpack_public_path__ + "static/media/archive_24px.d3030e09a96f25b870efde24cff7244a.svg";
export { ForwardRef as ReactComponent };